import { InOutKinds, InOutKindsName } from "../kinds/InOutKinds";
import { DateDuration } from "../../system";

// 証明期間
export class ReceptionProofPeriod {
  public displayOrder: number;
  public type: InOutKinds;
  public period: DateDuration;

  constructor(displayOrder: number) {
    this.displayOrder = displayOrder;
    this.type = InOutKinds.None;
    this.period = new DateDuration(null, null);
  }

  get typeName(): string {
    return InOutKindsName.getDisplayName(this.type);
  }

  get isEmpty(): boolean {
    return this.type === InOutKinds.None && (!this.period || this.period.from == null && this.period.to == null);
  }

  clone(index: number): ReceptionProofPeriod {
    const newObj = new ReceptionProofPeriod(index);
    newObj.type = this.type;
    newObj.period = this.period.clone();

    return newObj;
  }
}
